import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faTrash } from '@fortawesome/free-solid-svg-icons';
import '../../styles/AdminDataTable.css';

const BlogCategoriesTable = ({ 
  categories = [], 
  onEdit, 
  onDelete, 
  onCategorySelect, 
  selectedCategories = [], 
  onSelectAll 
}) => {
  const formatDate = (dateString) => {
    if (!dateString) return '-';
    return new Date(dateString).toLocaleDateString();
  };

  const truncateText = (text, maxLength = 45) => {
    if (!text || text.length <= maxLength) return text;
    return text.substring(0, maxLength) + '...';
  };

  return (
    <div className="admin-data-table__container">
      <table className="admin-data-table">
        <thead>
          <tr>
            <th>
              <input
                type="checkbox"
                checked={selectedCategories.length === categories.length && categories.length > 0}
                onChange={(e) => onSelectAll(e.target.checked)}
              />
            </th>
            <th>ID</th>
            <th>Name</th>
            <th>Description</th>
            <th>Status</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {categories.map((category) => (
            <tr key={category.id}>
              <td>
                <input
                  type="checkbox"
                  checked={selectedCategories.includes(category.id)}
                  onChange={(e) => onCategorySelect(category.id, e.target.checked)}
                />
              </td>
              <td>#{category.id}</td>
              <td>{category.name}</td>
              <td>
                <div className="description-cell" title={category.description || '-'}>
                  {truncateText(category.description, 15) || '-'}
                </div>
              </td>
              <td>
                <span className={`badge ${category.is_active ? 'badge-success' : 'badge-secondary'}`}>
                  {category.is_active ? 'Active' : 'Inactive'}
                </span>
              </td>
              <td>
                <div className="action-buttons">
                  <button
                    className="button secondary"
                    onClick={() => onEdit(category)}
                    title="Edit Category"
                  >
                    <FontAwesomeIcon icon={faEdit} />
                  </button>
                  <button
                    className="button secondary"
                    onClick={() => onDelete(category)}
                    title="Delete Category"
                  >
                    <FontAwesomeIcon icon={faTrash} />
                  </button>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      
      {categories.length === 0 && (
        <div className="no-data">
          <p>No blog categories found.</p>
        </div>
      )}
    </div>
  );
};

export default BlogCategoriesTable; 